import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { serverInfo } from "../../../../App";
import Vect from "../../../../Assets/Images/Group 1124.png";
import { LocationContext } from "../../../../CustomHelper/Helper";
import PaymentModal1 from "../../../Modal/PaymentModal/PaymentModal1";
import PaymentModalAudition from "../../../Modal/PaymentModal/PaymentModalAudition";
import MyVerticallyCenteredModal from "../../../RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";

import "../EnrollAudition/EnrollAudition.css";
import AuditionModal from "./AuditionModal";
// import AuditionModal1 from "./AuditionModal1";
import AuditionPaymentModal from "./AuditionPaymentModal";
import "./AuditionResult.css";
import CertificateModal from "./CertificateModal";
import { useFreeCost } from "../../../../CustomHooks/useFreeCost";

const AuditionResult = ({ roundInfo }) => {
  const { videoCdnUrl } = useContext(serverInfo);

  const [loading, setLoading] = React.useState(true);
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShow1, setModalShow1] = React.useState(false);
  const [modalShowCertificate, setModalShowCertificate] = React.useState(false);
  const [videoList, setVideoList] = React.useState([]);
  const [appealVideoList, setAppealVideoList] = useState([]);
  const [payModal, setPayModal] = React.useState(false);
  const [markTracking, setMarkTracking] = useState({});
  const [appealMarkTracking, setAppealMarkTracking] = useState({});
  const [isAppealedForThisRound, setIsAppealedForThisRound] = useState({});
  const [appealedRegistration, setAppealedRegistration] = useState({});
  const [videoType, setVideoType] = useState("general");
  const [isPaymentComplete, setIsPaymentComplete] = useState();
  const [certificateFee, setCertificateFee] = useState([]);


  const registerData = {
    event_id: roundInfo?.id,
    fee: roundInfo?.appeal_fee,
    payment_method: "Free-Appeal-Registaion",
  }
  const { freeRegistration, freeRegBuffer } = useFreeCost(registerData)



  const { paymentCount, paymentCountWithSymbol, payStatus } =
    useContext(LocationContext);

  const fetchUploadedVideo = (audition_id, round_info_id) => {
    setLoading(true);

    axios
      .get(
        `api/user/audition/uploaded_round_videos/${audition_id}/${round_info_id}`
      )
      .then((res) => {
        if (res?.data?.status === 200) {
          setVideoList(res?.data?.videos);
          setAppealVideoList(res?.data?.appeal_videos);
          setMarkTracking(res?.data?.auditionRoundMarkTracking);
          setAppealMarkTracking(res?.data?.appealAuditionRoundMarkTracking);
          setIsPaymentComplete(res?.data?.isPaymentCompleted);
          setCertificateFee(res?.data?.certificateFee?.fee);
        }
      });
  };

  const checkIsAppealForRound = (audition_id, round_info_id) => {
    axios
      .get(`api/user/audition/is_appeal/round/${audition_id}/${round_info_id}`)
      .then((res) => {
        if (res?.data?.status === 200) {
          setIsAppealedForThisRound(res?.data?.isAppealedForThisRound);
          if (res?.data?.isAppealedForThisRound == true) {
            setAppealedRegistration(res?.data?.appealedRegistration);
          }

          setLoading(false);
        }
      });
  };

  const handleAppealedVideo = () => {
    if (appealedRegistration?.id) {
      setVideoType("appeal");
    }
  };

  const handleGeneralVideo = () => {
    setVideoType("general");
  };

  useEffect(() => {
    fetchUploadedVideo(roundInfo.audition_id, roundInfo.id);
    checkIsAppealForRound(roundInfo.audition_id, roundInfo.id);
  }, [roundInfo.audition_id, roundInfo.id, roundInfo.video_slot_num]);

  useEffect(() => {
    fetchUploadedVideo(roundInfo.audition_id, roundInfo.id);
    checkIsAppealForRound(roundInfo.audition_id, roundInfo.id);
  }, [isAppealedForThisRound]);


  const ApplyAppealAndCertificate = (type) =>{

if(type === "audition-appeal"){
  if(roundInfo?.appeal_fee === 0){
    freeRegistration(type);
  }else{
    setModalShow(true)
  }
}else{
  if(certificateFee === 0){
    freeRegistration(type);
  }else{
    setModalShow1(true)
  }
}

  }
  return (
    <>
      {loading === true ? (
        <>
          <h5 className="text-white justify-content-center text-center mx-auto">
            Loading...
          </h5>
        </>
      ) : (
        <>
          <div className="m-3">
            <div className="row ">
              <div className="card bg-dark">
                {/* <div className="p-3">
                  <div className="d-flex justify-content-between">
                    <h4 className="text-center text-warning">
                      {videoType === "general" ? "Result" : "Appeal Result"}{" "}
                    </h4>
                  </div>
                </div> */}

                <div className="d-flex justify-content-around my-3">
                  <button
                    onClick={handleGeneralVideo}
                    className={
                      videoType === "general"
                        ? "btnLinear"
                        : "btnLinearInactive"
                    }
                  >
                    {/*
                   {videoType === "general" ? "Result" : "Appeal Result"}{" "}
                  */}
                    General Result
                  </button>
                  {Number(markTracking?.wining_status) == 1 ? (
                    <></>
                  ) : (
                    <>
                      {Number(roundInfo?.round_type) == 0 &&
                      Number(roundInfo?.appeal) == 1 ? (
                        <button
                          onClick={handleAppealedVideo}
                          className={
                            videoType == "appeal"
                              ? "btnLinear"
                              : "btnLinearInactive"
                          }
                        >
                          Appealed Result
                        </button>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </div>
                {videoType === "general" ? (
                  <>
                    <div className="row d-flex justify-content-center">
                      {videoList.map((data, i) => (
                        <video key={i} className="col-md-4" controls>
                          <source
                            src={
                              data.video != null
                                ? videoCdnUrl + data.video
                                : "https://youtu.be/dgfTiONcnTc"
                            }
                            type="video/mp4"
                          />
                        </video>
                      ))}
                    </div>

                    <div className="mb-3 mt-3 row justify-content-between BTsd p-2 mb-3 ">
                      <div className="col-md-1 IMGLs ps-2">
                        <img src={Vect} alt="" />
                      </div>
                      <div className="col-md-4 text-center BlackUou text-light YourT pt-3 fw-bold ms-3">
                        {markTracking?.type === "general"
                          ? "Your Total Mark"
                          : markTracking?.type === "wildcard"
                          ? "Your Total Video Feed Vote"
                          : "Your Total Mark"}
                      </div>
                      <div className="col-md-2 BlackUou BlackUouZ ">
                        <input
                          type="text"
                          readOnly
                          value={markTracking && markTracking?.avg_mark}
                          className="from-control wIn fw-bold mt-2"
                        />
                      </div>
                      <div
                        className={`col-md-4 ${
                          markTracking?.wining_status === 1
                            ? "bg-success"
                            : "bg-danger"
                        } text-center d-flex align-items-center justify-content-center BlackUouZ fw-bold rounded-3 py-1 text-light`}
                      >
                        {markTracking?.wining_status === 1 &&
                        markTracking?.type === "general"
                          ? "You are winner of the round"
                          : markTracking?.wining_status === 1 &&
                            markTracking?.type === "wildcard"
                          ? "You are winner via wildcard"
                          : markTracking?.wining_status === 1 &&
                            markTracking?.type === "oxygen"
                          ? "You are winner via Oxygen"
                          : markTracking?.wining_status === 0 &&
                            markTracking?.type === "rejected"
                          ? "You are rejected"
                          : "You are not Qualified for the next Round "}
                      </div>
                    </div>
                    {markTracking?.wining_status === 1 ? (
                      <>
                        <div className="row">
                          {/* Page no 587 */}
                          {isPaymentComplete ? (
                            <div className="mb-3 mt-3 row justify-content-between p-2 mb-5 ">
                              <div className="col-md-7 text-center BlackUou text-light pt-3 fw-bold ms-3">
                                Download Your Certificate
                              </div>

                              <div className="col-md-4  text-center fw-bold rounded-3 text-light py-1">
                                <button
                                  onClick={() => setModalShowCertificate(true)}
                                  className="btnAppD py-2 px-5 fw-bold"
                                >
                                  Download
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <div className="col-md-4 mx-auto">
                                <button
                                  className="btn btn-warning px-5 w-100 btnAppc my-4 fw-bold"
                                  onClick={()=>ApplyAppealAndCertificate('audition-certificate')}
                                >
                                  Apply for the certificate
                                </button>
                              </div>
                              {/* Page 586 */}
                            </div>
                          )}

                          {/* Page no 587 end */}
                        </div>
                      </>
                    ) : (
                      <>
                        {isAppealedForThisRound ? (
                          <>
                            <h2 className="text-warning text-center">
                              Already Appealed for this round!
                            </h2>
                          </>
                        ) : (
                          <>
                            {roundInfo?.round_type === 0 &&
                            roundInfo?.appeal === 1 ? (
                              <center>
                                <button
                                  className=" btnLinear px-5 w-50 btnApp mb-5 "
                                  onClick={()=>ApplyAppealAndCertificate('audition-appeal')}
                                >
                                  Appeal Request
                                </button>
                              </center>
                            ) : (
                              <></>
                            )}
                          </>
                        )}
                      </>
                    )}

                    <MyVerticallyCenteredModal
                      show={modalShow}
                      onHide={() => setModalShow(false)}
                      event_type="auditionAppeal"
                      // eventId={roundInfo.audition_id}
                      redirectTo="enrolled-auditions"
                      fee={paymentCount(roundInfo?.appeal_fee)}
                      baseFee={roundInfo?.appeal_fee}
                      event_id={roundInfo.id}
                    />

                    <MyVerticallyCenteredModal
                      show={modalShow1}
                      onHide={() => setModalShow1()}
                      event_type="auditionCertificate"
                      // eventId={roundInfo.audition_id}
                      redirectTo="enrolled-auditions"
                      fee={paymentCount(certificateFee)}
                      baseFee={certificateFee}
                      event_id={roundInfo.id}
                      setModalShow1={setModalShow1}
                      setIsPaymentComplete={setIsPaymentComplete}
                    />
                  </>
                ) : (
                  <>
                    <div className="row">
                      <div className="row">
                        {appealVideoList.map((data, i) => (
                          <video key={i} className="col-md-4" controls>
                            <source
                              src={
                                data.video != null
                                  ? videoCdnUrl + data.video
                                  : "https://youtu.be/dgfTiONcnTc"
                              }
                              type="video/mp4"
                            />
                          </video>
                        ))}
                      </div>
                    </div>

                    {appealMarkTracking?.wining_status != null ? (
                      <>
                        <div className="mb-3 mt-3 row justify-content-between BTsd p-2 mb-3 ">
                          <div className="col-md-1 IMGLs ps-2">
                            <img src={Vect} alt="" />
                          </div>
                          <div className="col-md-4 text-center BlackUou text-light YourT pt-3 fw-bold ms-3">
                            Your Total Mark for appeal
                          </div>
                          <div className="col-md-2 BlackUou BlackUouZ ">
                            <input
                              type="text"
                              readOnly
                              value={
                                appealMarkTracking &&
                                appealMarkTracking?.avg_mark
                              }
                              className="from-control wIn fw-bold mt-2"
                            />
                          </div>
                          <div
                            className={`col-md-4 ${
                              appealMarkTracking?.wining_status === 1
                                ? "bg-success"
                                : "bg-danger"
                            } text-center BlackUouZ fw-bold rounded-3 text-light py-1`}
                          >
                            {appealMarkTracking?.wining_status === 1
                              ? "You are Qualified for the next Round"
                              : appealMarkTracking?.wining_status === 0 &&
                                appealMarkTracking?.type === "appeal_rejected"
                              ? "You are rejected"
                              : "You are not Qualified for the next Round"}
                          </div>
                        </div>
                      </>
                    ) : (
                      <h3 className="text-warning text-center">
                        Applead Result Not Published Yet!
                      </h3>
                    )}
                  </>
                )}

                {/* Page 586 end */}
              </div>
            </div>
          </div>

          <CertificateModal
            show={modalShowCertificate}
            onHide={() => setModalShowCertificate(false)}
            auditionId={roundInfo.audition_id}
            roundInfoId={roundInfo.id}
          />
        </>
      )}
    </>
  );
};

export default AuditionResult;
